import React, { FC } from 'react';

import clx from 'classnames';
import { AliceApp } from 'client/model/skill';
import { isInstallableApp } from 'client/utils';
import { getSquareLogoUrl } from 'client/utils/settings/installable-app';

import { IconMedium } from '../AppIcons/AppIcons';

import styles from './AliceAppTitle.module.scss';

interface Props {
    aliceApp: AliceApp;
    hideAtMobile?: boolean;
}

export const AliceAppTitle: FC<Props> = ({ aliceApp, hideAtMobile }) => {
    const appName = aliceApp.name;

    let logoUrl = aliceApp.logo2?.url || aliceApp.draft?.logo2?.url || aliceApp.draft?.logoUrl || aliceApp?.logoUrl;
    if (isInstallableApp(aliceApp)) {
        logoUrl = getSquareLogoUrl(aliceApp);
    }

    return (
        <div className={clx(styles.aliceAppTitle__container, hideAtMobile && styles.aliceAppTitle_hideAtMobile)}>
            <IconMedium imageUrl={logoUrl} />
            <h1 className={styles.aliceAppTitle__header}>{appName}</h1>
        </div>
    );
};
